<ng-container *transloco="let t">
  @let resultResponse = searchResponse();
  @let nbResults = resultResponse?.total ?? 0;
  @if (resultResponse) {
    <div class="container-fluid position-relative pb-5 px-0">
      @if (!showFilters) {
        <div class="row gx-0">
          <div class="d-none d-md-block col-md-auto">
            <div class="px-4">
              <app-activity-search-filters></app-activity-search-filters>
            </div>
          </div>
          <div class="col-12 col-md px-0">
            <div class="row gx-0">
              <div class="col-12 col-lg">
                <div class="px-4 text-center text-lg-start">
                  <span class="text-primary">{{ nbResults === 1 ? t('activity.SearchResult.1Result') : t('activity.SearchResult.nResults', {n: nbResults}) }}</span>
                  @if (location()) {
                    pour <strong>{{ location() }}</strong>
                  }
                </div>
              </div>
              <div class="col-12 col-lg-auto">
                <div class="px-4 text-center">
                  informations fournies sans garantie
                </div>
              </div>
            </div>
            <div class="row gx-0">
              <div class="col-12">
                <app-activities-preview
                  [items]="resultResponse.results"
                  [isPublic]="true"
                  [showHost]="true"
                  [showDistance]="true">
                </app-activities-preview>
              </div>
            </div>
          </div>
        </div>
      }

      @if (showFilters) {
        <div class="row gx-0">
          <app-activity-search-filters></app-activity-search-filters>
        </div>
      }
    </div>
    <div class="bottom-menu d-md-none">
      <div class="btn-group btn-group-lg d-flex" role="group" aria-label="Filtrer">
        @if (showFilters) {
          <button type="button" class="btn btn-dark" (click)="resetFilters()">RÉINITIALISER</button>
          <button type="button" class="btn btn-primary" (click)="hideFilters()">
            AFFICHER
            {{ nbResults }}
            <lucide-icon [img]="icons.Filter"></lucide-icon>
          </button>
        } @else {
          <button type="button" (click)="toggleShowFilters()" class="btn btn-primary text-warning" >FILTRER <i class="bi bi-filter"></i></button>
        }

      </div>
    </div>
  }
</ng-container>

